import apiBaseUrl from '../../utils/config.js';

class DiagnosisCombinerService {
  constructor() {
    this.baseUrl = `${apiBaseUrl}/patientinfo`;
  }

  getToken() {
    return localStorage.getItem("jwt");
  }

  getAuthHeaders() {
    const token = this.getToken();
    return {
      'Content-Type': 'application/json',
      ...(token && { Authorization: `Bearer ${token}` }),
    };
  }

  async #request(endpoint, method, body = null) {
    const url = `${this.baseUrl}${endpoint}`;
    const options = {
      method,
      headers: this.getAuthHeaders(),
    };

    if (body) {
      options.body = JSON.stringify(body);
    }

    try {
      const response = await fetch(url, options);
      if (!response.ok) {
        const errorText = await response.text();
        throw new Error(`Request failed: ${errorText}`);
      }
      return response.json();
    } catch (error) {
      console.error(`Error in API request: ${error}`);
      throw error;
    }
  }

  async saveOrUpdate(diagnosisCombiner) {
    return this.#request('/save', 'POST', diagnosisCombiner);
  }

  async getAll() {
    return this.#request('/all', 'GET');
  }

  async getById(id) {
    return this.#request(`/${id}`, 'GET');
  }

  async getByAuthId(authId) {
    return this.#request(`/auth/${authId}`, 'GET');
  }

  async deleteById(id) {
    return this.#request(`/delete/${id}`, 'DELETE');
  }

  async updateDiagnosisInSet(id, index, newDiagnosis) {
    const params = new URLSearchParams({ newDiagnosis });
    return this.#request(`/${id}/updateDiagnosis/${index}?${params.toString()}`, 'PUT');
  }

  async updateProcedureInSet(id, index, newProcedure) {
    const params = new URLSearchParams({ newProcedure });
    return this.#request(`/${id}/updateProcedure/${index}?${params.toString()}`, 'PUT');
  }

  async deleteDiagnosisInSet(id, index) {
    return this.#request(`/${id}/deleteDiagnosis/${index}`, 'DELETE');
  }

  async deleteProcedureInSet(id, index) {
    return this.#request(`/${id}/deleteProcedure/${index}`, 'DELETE');
  }

  async getDiagnosisIdByAuthId(authId) {
    return this.#request(`/diagnosis-id/${authId}`, 'GET');
  }
}

export default DiagnosisCombinerService;
